module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.03e91f12.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/icons/linearicons/Linearicons-Free.woff2?w118d
// module id = ./src/assets/components/icons/linearicons/Linearicons-Free.woff2?w118d
// module chunks = 7